import React from 'react';
import PropTypes from 'prop-types';
import {Button, Modal, ModalBody, ModalHeader} from 'reactstrap';
import classnames from 'classnames';
import LocationListener from "../../common/LocationListener";

class SmartDialog extends React.Component{

    static propTypes = {
        showCancelButton: PropTypes.bool,
        onCancel: PropTypes.func,
        large: PropTypes.bool,
        title: PropTypes.any,
        onShow: PropTypes.func,
        onExit: PropTypes.func,
        canExit: PropTypes.func,
        modalClassName: PropTypes.string,
        contentClassName: PropTypes.string,
        classNames: PropTypes.string
    };

    constructor(props){
        super(props);

        this.state = {
            isOpen: false
        };

    }

    handleExit(){

        const props = this.props;
        if(props.canExit && !props.canExit()){
            return;
        }

        this.setState({
            isOpen: false
        });
    }

    /**
     * Shows the dialog
     */
    show(callback){

        this.setState({
            isOpen: true
        },callback);

    }

    /**
     * Hides the dialog
     */
    hide(){
        this.handleExit();
    }

    /**
     * Toggle the dialog's visibility
     */
    toggle(){

        if(this.state.isOpen){
            this.handleExit();
        }
        else{
            this.show();
        }

    }

    onCancel(){

        if(this.props.onCancel){
            this.props.onCancel();
        }
        else{
            this.toggle();
        }

    }

    render(){

        const state = this.state;
        const title = this.props.title;

        return <React.Fragment>
            <LocationListener onChange={() => this.hide()}/>
            <Modal contentClassName={this.props.contentClassName}
                   modalClassName={this.props.modalClassName}
                   isOpen={state.isOpen}
                   toggle={this.toggle.bind(this)}
                   className={ classnames(this.props.large ? "modal-lg" : null, this.props.classNames)}
                   onEnter={this.props.onShow}
                   onClosed={this.props.onExit}>

                {title && <ModalHeader toggle={this.toggle.bind(this)}>{title}</ModalHeader>}
                <ModalBody>
                    {this.props.children}
                    {this.props.showCancelButton && <div>
                        <hr/>
                        <div className="clearfix">
                            <div className="pull-right">
                                <Button color="link" onClick={this.onCancel.bind(this)}>Cancel</Button>
                            </div>
                        </div>
                    </div>}
                </ModalBody>
            </Modal>
        </React.Fragment>;
    }

}

export default  SmartDialog;


// WEBPACK FOOTER //
// ./src/components/SmartDialog/SmartDialog.js